var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isValidIcon)?_c('svg',{class:['icon', _vm.iconClassName],attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"1em","width":"1em","viewBox":`0 0 ${_vm.viewBoxHeight} ${_vm.viewBoxWidth}`}},[(_vm.iconTitle)?_c('title',[_vm._v(_vm._s(_vm.iconTitle))]):_vm._e(),_c(`Icon${this.iconName}`,{ref:"icon",tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }